export default {
  surveys: [],
  survey: {},
  results: [],
  currentSurveyResults: {}
};
